;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';

	var View = APP.module('View');
	var Collection = APP.module('Collection');

	View.TippingGamebar = Marionette.ItemView.extend({
		template: JST.TippingGamebar,

		initialize: function() {
			this.tippingModel = this.getOption('tippingModel');
			this.shareModel   = this.getOption('shareModel');
			const rounds = new Collection.Rounds();
			this.final_round_id = rounds.final_round_id || false;

			this.data = {};
			this.user = this.getOption('user');

			this.tippingModel.loadSnapshot().fetch().then(this.loadSnapshot.bind(this));

		},

		ui: {
			facebook_btn: '.js-facebook',
			twitter_btn:  '.js-twitter'
		},

		events: {
			'click @ui.facebook_btn': 'facebookShare',
			'click @ui.twitter_btn':  'twitterShare'
		},

		facebookShare: function(e){
			e.preventDefault();
			this.shareModel.share({
				type: 'facebook',
				user_id: this.user.get('id'),
				share_type: 'share'
			});

		},

		twitterShare: function(e){
			e.preventDefault();
			this.shareModel.share({
				type: 'twitter',
				user_id: this.user.get('id'),
				share_type: 'share'
			});
		},

		loadSnapshot: function() {
			const snapshot = this.tippingModel.checkAverage().toJSON();
			const current_round_id = snapshot.last_round.id;
			const is_final = this.final_round_id && current_round_id >= this.final_round_id;
			var final_value = current_round_id - this.final_round_id;
			const round_id = is_final ? current_round_id - this.final_round_id + 1 : current_round_id;
			let label = is_final ? 'FINALS WEEK ' : 'ROUND ';

			if (current_round_id === 0) {
				this.setTemplateData({
					snapshot,
					round_label: 'OPENING ROUND',
					avatars_url: CONFIG.AVATARS_URL,
					user:        this.user.toJSON()
				});
				return this;
			}

			if(final_value < 0 || !is_final) {
				this.setTemplateData({
					snapshot,
					round_label: "WEEK " + round_id,
					avatars_url: CONFIG.AVATARS_URL,
					user:        this.user.toJSON()
				});
			}

			if ((final_value === 0 || final_value === 1) && is_final) {
				label = 'Finals Week  ';
				this.setTemplateData({
					snapshot,
					round_label: label + round_id,
					avatars_url: CONFIG.AVATARS_URL,
					user:        this.user.toJSON()
				});
			}

			if (final_value === 2 && is_final) {
				label = 'Preliminary Finals';
				this.setTemplateData({
					snapshot,
					round_label: label,
					avatars_url: CONFIG.AVATARS_URL,
					user:        this.user.toJSON()
				});
			}

			if (final_value === 3 && is_final) {
				label = 'Grand Final';
				this.setTemplateData({
					snapshot,
					round_label: label,
					avatars_url: CONFIG.AVATARS_URL,
					user:        this.user.toJSON()
				});
			}
		},

		setTemplateData: function(obj) {
			_.extend(this.data, obj);
			this.getting_data = true;
			this.render();
			return this;
		},

		render: function () {
			var $this = this;
			if (!this.getting_data) {
				return this;
			}
			this.$el.html(this.template(this.data));

			return $this;
		}
	});

}(window, APP, Backbone, Marionette, $, _));